import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { Attendance, AttendanceState } from '../types/attendance';

const initialState: AttendanceState = {
  attendances: [],
  loading: false,
  error: null,
};

const attendanceSlice = createSlice({
  name: 'attendances',
  initialState,
  reducers: {
    fetchattendancesStart: (state) => {
      state.loading = true;
      state.error = null;
    },
    fetchattendancesSuccess: (state, action: PayloadAction<Attendance[]>) => {
      state.loading = false;
      state.attendances = action.payload;
    },
    fetchattendancesFailure: (state, action: PayloadAction<string>) => {
      state.loading = false;
      state.error = action.payload;
    },
    addattendanceStart: (state) => {
      state.loading = true;
      state.error = null;
    },
    addattendanceSuccess: (state, action: PayloadAction<Attendance>) => {
      state.loading = false;
      state.attendances.push(action.payload);
    },
    addattendanceFailure: (state, action: PayloadAction<string>) => {
      state.loading = false; 
      state.error = action.payload;
    },
    updateattendanceStart: (state) => {
      state.loading = true;
      state.error = null;
    },
    updateattendanceSuccess: (state, action: PayloadAction<Attendance>) => {
      state.loading = false;
      state.attendances = state.attendances.map((attendance) =>
        attendance.id === action.payload.id ? action.payload : attendance
      );
    },
    updateattendanceFailure: (state, action: PayloadAction<string>) => {
      state.loading = false;
      state.error = action.payload;
    },
    deleteattendanceStart: (state) => {
      state.loading = true;
      state.error = null;
    },
    deleteattendanceSuccess: (state, action: PayloadAction<number>) => {
      state.loading = false;
      state.attendances = state.attendances.filter((attendance) => attendance.id !== action.payload);
    },
    deleteattendanceFailure: (state, action: PayloadAction<string>) => {
      state.loading = false;
      state.error = action.payload;
    },
  },
  extraReducers: (builder) => {
    // No extra reducers needed since we are not using createAsyncThunk
  },
});

export const {
  fetchattendancesStart,
  fetchattendancesSuccess,
  fetchattendancesFailure,
  addattendanceStart,
  addattendanceSuccess,
  addattendanceFailure,
  updateattendanceStart,
  updateattendanceSuccess,
  updateattendanceFailure,
  deleteattendanceStart,
  deleteattendanceSuccess,
  deleteattendanceFailure,
} = attendanceSlice.actions;

export default attendanceSlice.reducer;